export const catCambios = {
    NoAplica: 0,
    CANCELACIONES: 4,
    CAMBIO_FECHA: 1,
    CAMBIO_PASAJERO: 3,
    CAMBIO_PAQUETE: 2,
}